import React from 'react';
import Error from '../../icons/error';
class AlertBox extends React.Component {
    render() {
        const { errors } = this.props;
        const { titleError, messageError } = errors
        return (
            <div className={`alert-box${titleError ? '' : '-hide'}`}>
                <div className='alert-title-container'>
                    <Error />
                    <span>{titleError}</span>
                </div>
                <div className='alert-message-container'>
                    <span>{messageError}</span>
                </div>
            </div>
        );
    }
}

export default AlertBox;
